import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

//import IconButton from '@material-ui/core/IconButton';
//import DeleteIcon from '@material-ui/icons/Delete';
//import EditIcon from '@material-ui/icons/Edit';

import TrueUpInvoiceContainer from '../../containers/accounting/TrueUpInvoice';
import QuickbooksContainer from '../../containers/accounting/Quickbooks';
import BulkCustomersContainer from '../../containers/logistics/BulkCustomers';
import AuthUserContainer from '../../containers/AuthUser';

import {statusClassNames } from '../../libs/utility';

//- UI
import FMPHeadline from "../../components/ui/FMPHeadline";
import FMPSectionHeader from "../../components/ui/FMPSectionHeader";
import documentIcon from '../../images/document.svg';
import attachIcon from '../../images/attachDocument.svg';
import noDeliveryIcon from '../../images/noDelivery.svg';
import FMPSelect from "../../components/pureForm/FMPSelect";

//- Form
import ResourceUploader from '../../components/form/ResourceUploader';
import FMPSubmitButton from '../../components/form/FMPSubmitButton';
import TrueUpInvoiceSendConfirmationDialog from "../../components/Dialogs/TrueUpInvoiceSendConfirmationDialog";

//- Pure form
import FMPDatePicker from "../../components/pureForm/FMPDatePicker";
import GenericSavingDialog from "../../components/Dialogs/GenericSavingDialog";
import FMPBulkCustomerSelect from "../../components/pureForm/FMPBulkCustomerSelect";
import FMPQuickbooksTermSelect from "../../components/pureForm/FMPQuickbooksTermSelect";
import ConfirmInvalidateTrueUpInvoiceDialog from "../../components/Dialogs/ConfirmInvalidateTrueUpInvoiceDialog";
import FMPCheckbox from "../../components/pureForm/FMPCheckbox";
import FMPText from "../../components/pureForm/FMPText";

const styles = (theme) => {
	return {
		...statusClassNames,
		paper: {
			width: '100%',
			overflowX: 'auto',
			textAlign : 'left',
			boxSizing: 'border-box',
			padding : 25,
			paddingBottom : 30,
			marginTop : 20,
			[theme.breakpoints.up('md')]: {
				padding : '10px 40px 40px 40px',
			}
		},
		inputGroup : {
			borderLeft : '5px solid #ccc',
			marginTop : 10,
			marginBottom: 20
		},
		submitButton : {
			fontSize : 18,
			borderRadius : '100px',
			padding : '20px 30px',
			textTransform: 'uppercase'
		},
		addInputButton : {
			borderRadius : '100px',
			marginTop : 20,
		},
		inset : {
			paddingLeft : 5,
			lineHeight : 1.3,
		},
		linkedTo : {
			fontSize : 20,
			paddingTop : 10,
		},
		linkedStatus : {
			fontSize : 15,
		},
		documentContainer : {
			display : 'flex',
			justifyContent : 'space-between',
			borderBottom : '1px solid #F1F1F1',
			paddingBottom : 7,
			marginBottom : 7,
			marginLeft : 10,
			marginTop : 10,
		},
		documentInfoContainer : {
			display : 'flex',
			justifyContent : 'flex-start',
		},
		documentInfo : {
			display : 'flex',
			flexDirection : 'column',
			justifyContent : 'center',
		},
		documentIcons : {
			whiteSpace : 'nowrap'
		},
		documentName: {
			fontWeight: 900,
		},
		button: {
		},
		missingDocumentName: {
			fontWeight: 900,
			color : '#777',
		},
		documentDetails: {
			fontWeight: 200,
		},
		documentRequired: {
			fontSize: 14,
			color : '#777',
		},
		missingRequiredDocs : {
			padding : 20,
			fontSize : 20,
			margin : '20px 10px',
			border : '1px solid #ddd',
			backgroundColor : '#f5f5f5',
		},
		documentIcon: {
			marginRight : 12,
			display : 'inline-block',
			width : 34,
			height : 40,
			backgroundImage: `url('${documentIcon}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			position : 'relative',
		},
		attachIcon : {
			display : 'inline-block',
			width : 21,
			height : 21,
			backgroundImage: `url('${attachIcon}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			position : 'absolute',
			bottom : 0,
			right : 0,
			transform : 'translate(30%, 30%)',
		},
		noDelivery : {
			fontSize : 18,
			color : '#666',
			display:'flex',
			alignItems : 'center',
		},
		noDeliveryIcon: {
			marginRight : 12,
			display : 'inline-block',
			width : 33,
			height : 34.5,
			backgroundImage: `url('${noDeliveryIcon}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			position : 'relative',
		},
		matchContainer : {
			backgroundColor : '#f7f7f7',
			padding: 15,
			fontSize : 15,
			fontWeight : 400,
			marginBottom : 10,
			marginTop : 5,
		},
		matchRow: {
			display : 'flex',
			marginBottom : 5,
		},
		warningIcon : {
			color : '#FFC107',
			width : 16,
			height : 16,
			paddingRight : 5,
			borderRight : '1px solid #f1f1f1',
			verticalAlign : 'middle',
		},
		checkIcon : {
			color: '#4CAF50',
			width: 16,
			height: 16,
			paddingRight: 5,
			verticalAlign : 'middle',
		},
		topErrors : {
			fontSize : 18,
			padding : 20,
			border : '2px solid #f44336',
			margin : 20,
			backgroundColor : 'white'
		},
		formulaContainer : {
			//border : '1px solid #eee',
			fontSize : 14,
			backgroundColor : '#f7f7f7',
			padding: '10px 15px 15px 15px',
			marginTop : 10,
			marginBottom : 5,
		},
		formulaTitle : {
			fontSize : 14,
			textTransform: 'uppercase',
			fontWeight : 800,
			color : '#333',
			paddingBottom : 25,
			paddingTop : 10,
		},
		formulaRow : {
			display : 'flex',
			flexDirection : 'row',
			paddingBottom : 2,
		},
		formulaRowBreak : {
			display : 'flex',
			flexDirection : 'row',
			paddingBottom : 2,
			paddingTop : 20,
		},
		formulaSubTitle : {
			paddingTop : 20,
			display : 'flex',
			flexDirection : 'row',
			textAlign : 'left',
			borderBottom: '.5px solid #ddd',
			textTransform: 'uppercase',
			paddingBottom : 2,
			marginBottom: 10,
			color: '#555',
		},
		formulaTotal : {
			borderTop : '2px solid #ccc',
			paddingTop : '5px',
			marginTop : '5px',
			display : 'flex',
			flexDirection : 'row',
			fontWeight : '800',
			paddingBottom : '15px',
		},
		formulaSubtotal : {
			marginLeft : '10%',
			marginRight : '10%',
			borderTop : '1px solid #ddd',
			paddingTop : '3px',
			marginTop : '3px',
			paddingBottom : '20px',
			display : 'flex',
			flexDirection : 'row',
			fontWeight : '800',
		},


		formulaLabel : {
			color : '#333',
			flexBasis : '50%',
			textAlign : 'right',
			paddingRight : '8px',
		},
		formulaValue : {
			color : '#666',
			flexBasis : '50%',
			textAlign : 'left',
		},
		formulaNote : {
			color : '#666',
			textAlign : 'left',
		},
		infoBox : {
			fontSize : 14,
			alignItems: 'center',
			display : 'flex',
			backgroundColor : '#f7f7f7',
			padding: '10px 15px 15px 15px',
			marginTop : 10,
			marginBottom : 5,
		},
		infoIcon : {
			color : '#2196F3',
			width : 32,
			height : 32,
			paddingRight : 5,
			verticalAlign : 'middle',
		},
	};
};


class SaveTrueUpInvoice extends Component {
	constructor(props) {
		super(props);
		const trueUpInvoiceId = _.get(
			this.props,
			['match', 'params', 'trueUpInvoiceId']
		);

		this.state = {
			isUpdate: (trueUpInvoiceId),
			trueUpInvoiceId: (trueUpInvoiceId) ? parseInt(trueUpInvoiceId, 10) : undefined,

			formFieldError: {},
			invoiceDocuments : [],
			isSendConfirmationOpen : false,
			isConfirmInvalidateOpen : false,

			//- Default form values
			isCredit : false,
			issueDate : moment().format('YYYY-MM-DD'),
			trueUpForYearMonth : moment().subtract(1, 'month').format('YYYY-MM'),
			quickbooksTermId : undefined,

			isSavingOpen : false,
			savingStatus : undefined,
			trueUpInvoiceForSending : undefined,

		};
	}

	componentDidMount() {
		const {
			trueUpInvoice, getTrueUpInvoice,
			quickbooksTerms, searchQuickbooksTerms,
			bulkCustomers, searchBulkCustomers,
		} = this.props;

		const {
			isUpdate,
			trueUpInvoiceId,
		} = this.state;

		if (_.isEmpty(quickbooksTerms)) {
			searchQuickbooksTerms();
		}

		if (_.isEmpty(bulkCustomers)) {
			searchBulkCustomers();
		}

		if (!isUpdate) { return; }

		if (!trueUpInvoice) {
			getTrueUpInvoice({
				params: {
					trueUpInvoiceIds: [trueUpInvoiceId]
				}
			});
		} else {
			const newState = this.fillForm();
			this.setState(newState);
		}
	}

	componentDidUpdate(prevProps) {
		if (
			_.isUndefined(prevProps.trueUpInvoice)
			&& !_.isUndefined(this.props.trueUpInvoice)
		) {
			const newState = this.fillForm();
			this.setState(newState);
		}
	}

	fillForm = () => {

		const {
			trueUpInvoice,
		} = this.props;

		if (!trueUpInvoice) {
			return;
		}

		const newState = {};
		[
			'productType',
			'bulkCustomerId',
			'issueDate',
			'quickbooksTermId',
			'isCredit',
			'total',
			'attachmentResourceId',
		].forEach(key => {
			if (_.isNil(trueUpInvoice[key])) {
				return;
			}
			newState[key] = trueUpInvoice[key];
		});

		const { trueUpForMonth, trueUpForYear} = trueUpInvoice;
		newState.trueUpForYearMonth = moment()
			.month(trueUpForMonth).year(trueUpForYear).format('YYYY-MM');
		return newState;


	};

	onChange = (value, path) => {
		const arrayPath = (_.isString(path))
			? _.toPath(path)
			: path;

		const val = (_.isObject(value) && value.target)
			? value.target.value
			: value;

		const basePath = _.head(arrayPath);
		let base = this.state[basePath];
		let newState = {};

		if (_.isArray(base) || _.isObject(base)) {
			base = _.cloneDeep(base);
			_.set(base, arrayPath.slice(1), val);
			newState[basePath] = base;
		} else {
			newState[basePath] = val;
		}

		this.setState(newState);
	};


	//- Dialogs
	closeSavingDialog = () => {
		this.setState({onContinue: false});
	};

	continueSavingDialog = () => {
		this.props.history.push(`/accounting/trueUpInvoices`);
	};

	closeSendConfirmationDialog = () => {
		this.setState({isSendConfirmationOpen: false});
		//this.props.history.push(`/accounting/trueUpInvoices`);
	};

	handleInvalidate = () => {
		this.setState({
			isConfirmInvalidateOpen : true,
		});
	};

	closeInvalidateDialog = () => {
		this.setState({isConfirmInvalidateOpen: false});
	};



	//- saving
	handleSave = () => {
		const { showErrors} = this.props;

		this.save({
			callback : (err, r) => {
				if (err) {
					this.setState({ isSavingOpen : false });
					return showErrors((_.isArray(err)) ? err : [err]);
				}

				const trueUpInvoice = _.get(r, ['collections','trueUpInvoiceCollection', 0]);
				if (!trueUpInvoice) {
					this.setState({ isSavingOpen : false });
					return showErrors(['Save did not return true up invoice']);
				}

				this.setState({
					trueUpInvoiceForSending : trueUpInvoice,
					savingStatus : 'done'
				});
			}
		});
	};

	handleSaveAndSend = () => {
		const { showErrors} = this.props;
		this.save({
			callback : (err, r) => {
				if (err) {
					this.setState({ isSavingOpen : false });
					return showErrors((_.isArray(err)) ? err : [err]);
				}

				const trueUpInvoice = _.get(r, ['collections','trueUpInvoiceCollection', 0]);
				if (!trueUpInvoice) {
					this.setState({ isSavingOpen : false });
					return showErrors(['Save did not return station invoice']);
				}

				this.setState({
					trueUpInvoiceForSending : trueUpInvoice,
					savingStatus : 'done',
				});

				setTimeout(() => {
					this.setState({
						isSavingOpen : false,
						isSendConfirmationOpen: true,
					});
				}, 500);

			}
		});
	};

	save = ({ callback }) => {
		const {
			addTrueUpInvoice,
			updateTrueUpInvoice,
		} = this.props;

		//- Required fields
		const formFieldError = {};
		const errors = [];

		const _setError = (path, error) => {
			_.set(formFieldError, path, error);
			errors.push(error);
		};

		let fields = [
			{fieldName: 'productType', display: 'Product Type'},
			{fieldName: 'bulkCustomerId', display: 'Bulk Customer'},
			{fieldName: 'issueDate', display: 'Issue Date'},
			{fieldName: 'trueUpForYearMonth', display: 'True Up For Month'},

			{fieldName: 'quickbooksTermId', display: 'Quickbooks Term'},
			{fieldName: 'total', display: 'Total'},
			{fieldName: 'attachmentResourceId', display: 'Attachment'},
		];

		fields.forEach(s => {
			if (!this.state[s.fieldName]) {
				_setError([s.fieldName], `${s.display} is required`);
			}
		});

		if (!_.isEmpty(errors)) {
			this.setState({formFieldError});
			return callback(errors);
		}

		//- Get all the values and do individual checks
		const {
			productType,
			trueUpInvoiceId,
			isUpdate,
			bulkCustomerId,
			issueDate,
			quickbooksTermId,
			isCredit,
			total,
			attachmentResourceId,
			trueUpForYearMonth,
		} = this.state;

		if (!_.isEmpty(errors)) {
			this.setState({formFieldError});
			return callback(errors);
		}

		const trueUpForMoment = moment(trueUpForYearMonth, 'YYYY-MM');


		//- Lock and load
		const params = {
			productType,
			bulkCustomerId,
			isUpdate,
			issueDate,
			quickbooksTermId,
			isCredit,
			total,
			attachmentResourceId,

			trueUpForMonth : trueUpForMoment.month(),
			trueUpForYear : trueUpForMoment.year(),
		};
		params.total = parseFloat(total);

		this.setState({
			isSavingOpen: true,
			savingStatus : 'saving'
		});

		if (!isUpdate) {
			addTrueUpInvoice({
				params,
				callback
			});
		} else {
			params.trueUpInvoiceId = trueUpInvoiceId;
			updateTrueUpInvoice({
				params,
				callback
			});
		}
	};

	handleDataFileUpload = ({ resource }) => {
		this.setState({ attachmentResourceId : resource.resourceId });
	};

	getInputProps = (path) => {
		return {
			path,
			value  : this.getValue(path),
			error : this.getError(path),
			onChange : this.onChange,
			checked : this.getValue(path, false),
			md : 6,
		};
	};

	getValue  = (path, defaultValue) => {
		const _d = (_.isUndefined(defaultValue)) ? '' : defaultValue;
		return _.get(this.state, path, _d);
	};
	getError = (path) => {
		return _.get(this.state.formFieldError, path);
	};


	render() {
		const {
			authUser,
			classes,
			trueUpInvoice,
			bulkCustomers,
			quickbooksTerms,
			resourceMap,
			invalidateTrueUpInvoice,
			showErrors,
		} = this.props;

		const {
			isUpdate,
			trueUpInvoiceId,
			attachmentResourceId,
			isSendConfirmationOpen,
			isSavingOpen,
			savingStatus,
			errors,
			trueUpInvoiceForSending,
			isConfirmInvalidateOpen,
			productType,
		} = this.state;

		//- Check if data is loaded yet
		if (!quickbooksTerms.length || !bulkCustomers.length) {
			return (<div>Fetching information...</div>);
		}

		if (isUpdate && !trueUpInvoice) {
			return (<div>Fetching station invoice information...</div>);
		}

		//const verb = (isUpdate) ? 'Update' : 'Add';
		const headline = (isUpdate)
			? `Update True Up Invoice #${trueUpInvoiceId}`
			: `Add True Up Invoice`;

		let resource;
		if (attachmentResourceId) {
			resource = resourceMap[attachmentResourceId];
		}

		let trueUpBulkCustomers = [];

		if (productType === 'bulkEthanol') {
			trueUpBulkCustomers = _.filter(bulkCustomers, bulkCustomer => {
				const {trueUpFormula} = bulkCustomer;
				if (trueUpFormula) { return true; }
			});
		}
		else if (productType === 'e85') {
			trueUpBulkCustomers = _.filter(bulkCustomers, bulkCustomer => {
				const {invoiceQuickbooksCustomerId} = bulkCustomer;
				return invoiceQuickbooksCustomerId === '59' || invoiceQuickbooksCustomerId === '6948';
			});
		} else {
			trueUpBulkCustomers = [{ name : 'Please pick a product type', bulkCustomerId : 0}];
		}

		const pastMonths = [];
		_.range(12).forEach(i => {
			const m = moment().subtract(i, 'months');
			pastMonths.push({
				value : m.format('YYYY-MM'),
				display : m.format('MMMM, YYYY')
			});
		});

		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>

					{!_.isEmpty(errors) &&
					<div className={classes.topErrors}>
						{errors.map(error => { return error;})}
					</div>
					}

					<FMPHeadline label={headline} />
					<Paper className={classes.paper}>

						<FMPSectionHeader label={'Customer Info'} />
						<FMPSelect
							{...this.getInputProps('productType')}
							label='Product Type'
							options={[
								{ value : 'bulkEthanol', display : 'Bulk Ethanol'},
								{ value : 'e85', display : 'E85'},
							]}
						/>

						<FMPBulkCustomerSelect
							{...this.getInputProps('bulkCustomerId')}
							bulkCustomers={trueUpBulkCustomers}
							label={'Customer'}
						/>

						<FMPSectionHeader label={'Invoice Info'} />

						<FMPSelect
							label={`True Up for which month`}
							{...this.getInputProps('trueUpForYearMonth')}
							options={pastMonths}
						/>

						<FMPDatePicker
							{...this.getInputProps('issueDate')}
							label={'Issue Date'}
						/>

						<FMPQuickbooksTermSelect
							{...this.getInputProps('quickbooksTermId')}
							quickbooksTerms={quickbooksTerms}
						/>

						<FMPText
							{...this.getInputProps('total')}
							label={'Total'}
						/>

						<FMPCheckbox
							{...this.getInputProps('isCredit')}
							label={"This is a credit"}
							value={'isCredit'}
						/>

						<FMPSectionHeader label={'Attachment'} />

						<Grid container spacing={3}>
							<Grid item xs={12} md={6}>

								{!!resource &&
								<Grid container spacing={3} style={{marginTop: 10}}>
									<Grid item xs={11} md={6}>
										<div>
											<span role="img" aria-label="success">✅</span>
											File uploaded successfully
										</div>
									</Grid>
									<Grid item xs={11} md={6}>
										{resource.contentType}
									</Grid>
								</Grid>
								}

								<ResourceUploader
									name={'dataFileResourceId'}
									label={''}
									afterUpload={this.handleDataFileUpload}
									onlyOne={true}
								/>
							</Grid>
						</Grid>

						{authUser.userId === 14 &&
						<Grid container spacing={3}>
							<Grid item xs={6}>
								<Button onClick={() => {
									this.handleDataFileUpload({resource: {resourceId: 777777777}});
								}}>
									DWP Test Document
								</Button>
							</Grid>
						</Grid>
						}

						{this.renderButtons({
							trueUpInvoice,
							isUpdate,
						})}

					</Paper>

					<GenericSavingDialog
						open={isSavingOpen}
						onClose={this.closeSavingDialog}
						onContinue={this.continueSavingDialog}
						processingText={"Processing and saving invoice."}
						successText={"Invoice saved successfully."}
						status={savingStatus}
					/>

					<TrueUpInvoiceSendConfirmationDialog
						trueUpInvoice={trueUpInvoiceForSending}
						open={isSendConfirmationOpen}
						onClose={this.closeSendConfirmationDialog}
						history={this.props.history}
					/>

					<ConfirmInvalidateTrueUpInvoiceDialog
						open={isConfirmInvalidateOpen}
						onClose={this.closeInvalidateDialog}
						trueUpInvoice={trueUpInvoice}
						invalidateTrueUpInvoice={invalidateTrueUpInvoice}
						showErrors={showErrors}
						history={this.props.history}
					/>

				</Grid>
			</Grid>
		);
	}

	renderButtons = ({ bulkInvoice, isUpdate }) => {

		const status = _.get(bulkInvoice, ['status'], 'new');

		if (status === 'issued' && isUpdate) {
			return (
				<div style={{textAlign : 'right', margin : '20px 10px'}}>
					<Button
						onClick={this.handleInvalidate}
						variant="outlined"
						style={{margin:'0px 10px'}}
					>
						Mark Invalid
					</Button>

					<Button
						onClick={this.handleSave}
						variant="outlined"
						color="primary"
						style={{margin:'0px 10px'}}
					>
						Save Invoice
					</Button>
				</div>
			);
		}

		return (
			<div style={{textAlign : 'right', margin : '20px 10px'}}>
				<Button
					onClick={this.handleSave}
					variant="outlined"
					color="primary"
					style={{margin:'0px 10px'}}
				>
					Save Invoice
				</Button>

				<FMPSubmitButton
					onClick={this.handleSaveAndSend}
					buttonText={`Save & Send Invoice`}
					disabledText={"Missing required delivery documents"}
				/>
			</div>
		);
	};
}

SaveTrueUpInvoice.propTypes = {
	authUser : PropTypes.object,
	getTrueUpInvoice : PropTypes.func.isRequired,
	trueUpInvoice : PropTypes.object,

	searchBulkCustomers : PropTypes.func.isRequired,
	bulkCustomers : PropTypes.array,

	resourceMap : PropTypes.object,

	addTrueUpInvoice : PropTypes.func.isRequired,
	updateTrueUpInvoice : PropTypes.func.isRequired,
	invalidateTrueUpInvoice : PropTypes.func.isRequired,

	searchQuickbooksTerms : PropTypes.func.isRequired,
	quickbooksTerms : PropTypes.array,

	convertToPages : PropTypes.func,

	classes: PropTypes.object.isRequired,
	theme: PropTypes.object.isRequired,
	showErrors : PropTypes.func.isRequired,
	history : PropTypes.object.isRequired,
};

export default _.flow([
	withStyles(styles, { withTheme: true }),
	AuthUserContainer,
	TrueUpInvoiceContainer,
	QuickbooksContainer,
	BulkCustomersContainer,
])(SaveTrueUpInvoice);
